import { createClient } from '@supabase/supabase-js'

const supabaseUrl = "https://qtydevnghftbunqvpyyo.supabase.co"
const supabaseAnonKey = 'sb_publishable_pmWX5FiLCQjop9LrBk5hhw_CZCKbsah'
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
